<section class="box mt-10 mb-10 text-sm bg-white shadow-md rounded-md">
    <div class="p-5">
        <h1 class="text-red-800">General Instructions</h1>
        <p>The tests included in the medical examination are as prescribed by the Immigration authorities of
            Australia/New
            Zealand/Canada/UK. If required, additional tests are to be done as per their protocol.</p>
        <div class="flex">
            <div class="flex-1 w-64 p-1">
                <span class="text-medium">The tests depend on:</span>
                <ul>
                    <li>Type of visa
                    <li>Length of stay</li>
                    <li>Age of applicant</li>
                    <li>Any medical issues in medical examination</li>
                </ul>

                <p>Your online appointment confirmation is subject to the payment of fees as mentioned below. This
                    amount
                    will
                    be adjusted against your visa medical charges.</p>
                <ul>
                    <li>UK – Medicals
                        2500 INR</li>
                    <li>Australia | New Zealand | Canada – Medicals
                        1500 INR (Advance)</li>
                </ul>
                <p>For enquiries contact: 0471 294 1938 | 1950 | 1312 between 8.00 am and 5.30 pm, Monday to Saturday.
                    Email us at <span class="font-bold">visamedicals&#64;kimshealth.org</span></p>
            </div>
            <div class="flex-1 w-32 p-1">
                <p>Informed consent is signed by every applicant as authorized by the Immigration Departments of
                    Australia |
                    New Zealand | Canada | UK.
                    Parent or guardian should sign on behalf of minor children* and persons with intellectual
                    disability.
                </p>

                <ul>
                    <li>
                        *Under 16 years for Australia, Canada and UK</li>
                    <li>*Under 18 years for New Zealand</li>
                </ul>
                <p>Medical examination reports for Australia | New Zealand | Canada will be submitted on e-Medical
                    portal within 2 to 5 working days</p>
                <h4>Other Instructions:</h4>
                <ul>
                    <li>Fasting is not required </li>
                    <li>If you use spectacles, please bring them</li>
                    <li>If you have any medical history, please bring medical reports</li>
                    <li>Females in their menstrual cycle are advised to postpone their appointments</li>
                    <li>Kindly avoid carrying valuable items with you while visiting hospital for medical examination</li>
                </ul>
            </div>
        </div>
    </div>
</section>